import React from 'react';
import { OrganogramModel } from '../../../../Models/OrganogramModel';
import { EditAction } from '../../../../shared/enum/EditAction';
import { OrganogramAccordionItem } from './OrganogramAccordionItem';
export interface IOrganogramListProps {
    listOrg: OrganogramModel[],
    parent: number | null,
    level: number,
    textLevel: string
}

export function OrganogramList({listOrg, parent, level, textLevel }: IOrganogramListProps) {
    const items = listOrg.filter(x => x.parentId == parent);    
    
    return (
        <>
            {items.map((organogram) => {
                const childrens = listOrg.filter(x => organogram.id === x.parentId);
                const isParent = childrens.length > 0;

                if (organogram.editAction != EditAction.DELETE)
                    return (
                        <OrganogramAccordionItem
                            key={organogram.id}	
                            organogram={organogram}
                            textLevel={textLevel}
                            isParent={isParent}
                            level={level}
                            listOrg={listOrg}
                        />
                    );
            })}
        </>        
    );
}